/* eslint-disable import/no-anonymous-default-export */

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 100
	}
};

export default {
	DEFAULT_CONFIG
};
